/**
 * "Only the latest load writes": each load takes a ticket, and only the most recent ticket may write its result or
 * clear the loading state, so a slow earlier load cannot overwrite a newer one.
 */
export function createLatestRequestGuard(): { next: () => number; isLatest: (ticket: number) => boolean } {
  let latest = 0;
  return {
    next: () => ++latest,
    isLatest: (ticket) => ticket === latest,
  };
}

/** Portal appointment list refresh cadence (replaces the Appointment websocket subscription). */
export const PORTAL_APPOINTMENT_POLL_MS = 60_000;

/**
 * Calls `onTick` every {@link PORTAL_APPOINTMENT_POLL_MS} while the page is visible (a hidden tab skips the tick).
 * Client policies cannot subscribe to Appointment (websocket notifications skip hiddenFields), so staff-side changes
 * reach the portal this way. Returns the cleanup.
 */
export function startVisiblePoll(onTick: () => void): () => void {
  const interval = setInterval(() => {
    if (document.visibilityState === 'visible') onTick();
  }, PORTAL_APPOINTMENT_POLL_MS);
  return () => clearInterval(interval);
}
